// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormikDatePicker_wrapper__XO6gk","icon":"FormikDatePicker_icon__2hQl0","datePicker":"FormikDatePicker_datePicker__2NEVO","popper":"FormikDatePicker_popper__2npa3"};